import * as React from "react";
import * as Font from "expo-font";

import { handleError } from "~/utils/logger";

export const useLoadResources = () => {
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        await Font.loadAsync({
          "SFProDisplay-Regular": require("../../../../assets/fonts/SFProDisplay-Regular.ttf"),
          "SFProDisplay-Medium": require("../../../../assets/fonts/SFProDisplay-Medium.ttf"),
          "SFProDisplay-Bold": require("../../../../assets/fonts/SFProDisplay-Bold.ttf"),
          "Inter-Regular": require("../../../../assets/fonts/Inter-Regular.ttf"),
          "Inter-SemiBold": require("../../../../assets/fonts/Inter-SemiBold.ttf"),
          "Inter-Bold": require("../../../../assets/fonts/Inter-Bold.ttf"),
          "Lora-Regular": require("../../../../assets/fonts/Lora-Regular.ttf"),
          "Lora-Italic": require("../../../../assets/fonts/Lora-Italic.ttf"),
          "Lora-Medium": require("../../../../assets/fonts/Lora-Medium.ttf"),
          // This is a variation of Lora font with a custom position of the number characters
          "Lora-Regular-Superscript": require("../../../../assets/fonts/Lora-Regular-Superscript.ttf"),
          "Montserrat-Regular": require("../../../../assets/fonts/Montserrat-Regular.ttf"),
          "Montserrat-Light": require("../../../../assets/fonts/Montserrat-Light.ttf"),
          "Montserrat-Medium": require("../../../../assets/fonts/Montserrat-Medium.ttf"),
          "Montserrat-SemiBold": require("../../../../assets/fonts/Montserrat-SemiBold.ttf"),
          "Montserrat-Bold": require("../../../../assets/fonts/Montserrat-Bold.ttf"),
          "Roboto-Regular": require("../../../../assets/fonts/Roboto-Regular.ttf"),
          "SFCompactDisplay-Regular": require("../../../../assets/fonts/SFCompactDisplay-Regular.ttf"),
          "SFProText-Regular": require("../../../../assets/fonts/SFProText-Regular.ttf"),
          "SFProDisplay-RegularItalic": require("../../../../assets/fonts/SFProDisplay-RegularItalic.ttf"),
          Courier: require("../../../../assets/fonts/Courier.ttf"),
          "MaterialIcons-Regular": require("../../../../assets/fonts/MaterialIcons-Regular.ttf"),
          MaterialCommunityIcons: require("../../../../assets/fonts/MaterialCommunityIcons.ttf"),
        });
      } catch (e) {
        handleError(e);
      }
    }
    loadResourcesAndDataAsync();
  }, []);
};
